// automatically generated by the FlatBuffers compiler, do not modify

import { flatbuffers } from "flatbuffers"
import * as NS1989752507 from "./transform_generated";
/**
 * @constructor
 */
export namespace RockIt{
export class Animation {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  bb: flatbuffers.ByteBuffer;

  /**
   * @type {number}
   */
  bb_pos:number = 0;
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Animation}
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Animation {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Animation=} obj
 * @returns {Animation}
 */
static getRootAsAnimation(bb:flatbuffers.ByteBuffer, obj?:Animation):Animation {
  return (obj || new Animation).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
name():string|null
name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
name(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
speed():number {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @param {number} index
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array}
 */
vox(index: number):string
vox(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
vox(index: number,optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
voxLength():number {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
static startAnimation(builder:flatbuffers.Builder) {
  builder.startObject(3);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} nameOffset
 */
static addName(builder:flatbuffers.Builder, nameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, nameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} speed
 */
static addSpeed(builder:flatbuffers.Builder, speed:number) {
  builder.addFieldFloat32(1, speed, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} voxOffset
 */
static addVox(builder:flatbuffers.Builder, voxOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, voxOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
static createVoxVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
static startVoxVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
static endAnimation(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

}
}
/**
 * @constructor
 */
export namespace RockIt{
export class Vox {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  bb: flatbuffers.ByteBuffer;

  /**
   * @type {number}
   */
  bb_pos:number = 0;
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Vox}
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Vox {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Vox=} obj
 * @returns {Vox}
 */
static getRootAsVox(bb:flatbuffers.ByteBuffer, obj?:Vox):Vox {
  return (obj || new Vox).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
size():number {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
position(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
rotation(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @param {number} index
 * @param {RockIt.Animation=} obj
 * @returns {RockIt.Animation}
 */
animation(index: number, obj?:RockIt.Animation):RockIt.Animation|null {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? (obj || new RockIt.Animation).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};

/**
 * @returns {number}
 */
animationLength():number {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
default():string|null
default(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
default(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb.__offset(this.bb_pos, 12);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
jitter():number {
  var offset = this.bb.__offset(this.bb_pos, 14);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
static startVox(builder:flatbuffers.Builder) {
  builder.startObject(6);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 */
static addSize(builder:flatbuffers.Builder, size:number) {
  builder.addFieldFloat32(0, size, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} positionOffset
 */
static addPosition(builder:flatbuffers.Builder, positionOffset:flatbuffers.Offset) {
  builder.addFieldStruct(1, positionOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} rotationOffset
 */
static addRotation(builder:flatbuffers.Builder, rotationOffset:flatbuffers.Offset) {
  builder.addFieldStruct(2, rotationOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} animationOffset
 */
static addAnimation(builder:flatbuffers.Builder, animationOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, animationOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
static createAnimationVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
static startAnimationVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} defaultOffset
 */
static addDefault(builder:flatbuffers.Builder, defaultOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, defaultOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} jitter
 */
static addJitter(builder:flatbuffers.Builder, jitter:number) {
  builder.addFieldFloat32(5, jitter, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
static endVox(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

}
}
/**
 * @constructor
 */
export namespace RockIt{
export class Light {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  bb: flatbuffers.ByteBuffer;

  /**
   * @type {number}
   */
  bb_pos:number = 0;
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Light}
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Light {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Light=} obj
 * @returns {Light}
 */
static getRootAsLight(bb:flatbuffers.ByteBuffer, obj?:Light):Light {
  return (obj || new Light).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
color():number {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
position(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @returns {number}
 */
intensity():number {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 1.0;
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
target(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
static startLight(builder:flatbuffers.Builder) {
  builder.startObject(4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} color
 */
static addColor(builder:flatbuffers.Builder, color:number) {
  builder.addFieldInt32(0, color, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} positionOffset
 */
static addPosition(builder:flatbuffers.Builder, positionOffset:flatbuffers.Offset) {
  builder.addFieldStruct(1, positionOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} intensity
 */
static addIntensity(builder:flatbuffers.Builder, intensity:number) {
  builder.addFieldFloat32(2, intensity, 1.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} targetOffset
 */
static addTarget(builder:flatbuffers.Builder, targetOffset:flatbuffers.Offset) {
  builder.addFieldStruct(3, targetOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
static endLight(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

}
}
/**
 * @constructor
 */
export namespace RockIt{
export class Camera {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  bb: flatbuffers.ByteBuffer;

  /**
   * @type {number}
   */
  bb_pos:number = 0;
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Camera}
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Camera {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Camera=} obj
 * @returns {Camera}
 */
static getRootAsCamera(bb:flatbuffers.ByteBuffer, obj?:Camera):Camera {
  return (obj || new Camera).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
rotation(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
position(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
target(obj?:NS1989752507.RockIt.Vec3):NS1989752507.RockIt.Vec3|null {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? (obj || new NS1989752507.RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
static startCamera(builder:flatbuffers.Builder) {
  builder.startObject(3);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} rotationOffset
 */
static addRotation(builder:flatbuffers.Builder, rotationOffset:flatbuffers.Offset) {
  builder.addFieldStruct(0, rotationOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} positionOffset
 */
static addPosition(builder:flatbuffers.Builder, positionOffset:flatbuffers.Offset) {
  builder.addFieldStruct(1, positionOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} targetOffset
 */
static addTarget(builder:flatbuffers.Builder, targetOffset:flatbuffers.Offset) {
  builder.addFieldStruct(2, targetOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
static endCamera(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

}
}



// WEBPACK FOOTER //
// ./src/common/component/webgl_generated.ts